<template>
  <div class="inventoriedClass">
    <main class="list-table mt-5">
      <div class="row">
        <div class="col-md-12">
          <div class="form d-flex align-items-center">
            <p>{{ $t("lostItems.tabs.Inventoried.text") }}</p>
            <Json2Csv
              class="ml-auto"
              v-if="items.length > 0"
              :json-data="csvData"
              :csv-title="`Lost_Items_Inventoried`"
            >
              <button class="btn btn-download">
                {{ $t("lostItems.btnDownload") }}
              </button>
            </Json2Csv>
          </div>
        </div>
      </div>
      <v-client-table
        v-if="items"
        :columns="table_options.columns"
        :options="table_options.options"
        :data="items"
      >
        <!-- Actions -->

        <template v-slot:inventoryDate="props"
          >{{ props.row.formatDate }}, {{ props.row.formatTime }}</template
        >
        <template v-slot:resolutionAction="props">
          <div class="resolution">
            <!-- @click="openModal(props.row)" -->
            <button @click="openModal(props.row)" class="btn btn-resolution">
              {{
                $t("lostItems.tabs.Inventoried.table.headings.resolutionAction")
              }}
            </button>
          </div>
        </template>
        <template v-slot:actions="props">
          <div class="actions">
            <!-- Delete -->
            <i
              @click="openModal(props.row, (del = true))"
              class="far fa-trash-alt"
            ></i>
            <!-- Delete -->
            <!-- Detalles-->
            <router-link
              class="details"
              :to="{
                name: 'Lost Item Detail',
                params: {
                  id: props.row.id,
                  object: props.row
                }
              }"
            >
              <i class="far fa-eye"></i>
            </router-link>
          </div>
        </template>
      </v-client-table>
    </main>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 v-if="isToDelete" class="modal-title bolded">
          {{ $t("lostItems.tabs.collectionRequests.modal.attention") }}
        </h6>
        <h6 v-if="!isToDelete" class="modal-title">
          {{ $t("lostItems.tabs.Inventoried.table.headings.resolutionAction") }}
        </h6>
      </template>
      <div class="row" v-if="resolutionError">
        <div class="col-md-12 error">
          <p>{{ $t("lostItems.tabs.Inventoried.errorText") }}</p>
        </div>
      </div>
      <template>
        <div class="modal-body-text">
          <p v-if="!isToDelete">
            {{ $t("lostItems.tabs.Inventoried.modal.body") }}
            <span class="bolded">{{ this.itemToDelete.itemInfo }}</span>
          </p>
          <div class="radio-btn" v-if="!isToDelete">
            <div class="group">
              <input
                v-model="resolution"
                value="delivered"
                type="radio"
                id="delivery"
                name="radio"
              />
              <label for="delivery">{{
                $t("lostItems.tabs.Inventoried.modal.delivery")
              }}</label>
            </div>
            <div class="group mt-3">
              <input
                v-model="resolution"
                value="donated"
                type="radio"
                id="donated"
                name="radio"
              />
              <label for="donated">{{
                $t("lostItems.tabs.Inventoried.modal.donated")
              }}</label>
            </div>
            <div class="group mt-3">
              <input
                v-model="resolution"
                value="destroyed"
                type="radio"
                id="destroyed"
                name="radio"
              />
              <label for="destroyed">{{
                $t("lostItems.tabs.Inventoried.modal.destroyed")
              }}</label>
            </div>
          </div>
          <p v-if="isToDelete">
            {{ $t("lostItems.tabs.collectionRequests.modal.delete-text") }}
          </p>
          <p v-if="isToDelete" class="mt-1">
            {{ $t("lostItems.tabs.collectionRequests.modal.body-text2") }}
          </p>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">{{
            $t("map.benefits.list.modal.cancel")
          }}</span>
          <button
            type=" button"
            class="btn control solve-btn"
            v-if="isToDelete"
            @click="deleteItem(itemToDelete)"
          >
            {{ $t("lostItems.tabs.collectionRequests.modal.continue") }}
          </button>
          <button
            type=" button"
            class="btn control solve-btn"
            v-if="!isToDelete"
            :disabled="resolution === ''"
            @click="updateItem(itemToDelete)"
          >
            {{ $t("lostItems.tabs.Inventoried.modal.solve") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/lostItems.js";
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");
import moment from "moment";
import Json2Csv from "vue-json-to-csv";

export default {
  components: {
    Modal,
    Json2Csv
  },
  data() {
    return {
      items: null,
      folio: "",
      page: 0,
      categories: [],
      modalActive: false,
      resolution: "",
      formatDate: "",
      itemToDelete: null,
      isToDelete: false,
      csvData: null,
      dictionary: {
        folio: this.$t("lostItems.tabs.Inventoried.table.headings.folio"),
        itemInfo: this.$t("lostItems.tabs.Inventoried.table.headings.itemInfo"),
        formatTime: this.$t(
          "lostItems.tabs.Inventoried.table.headings.timeInventoried"
        ),
        formatDate: this.$t(
          "lostItems.tabs.Inventoried.table.headings.inventoryDate"
        ),
        placeCollection: this.$t(
          "lostItems.tabs.Inventoried.table.headings.placeCollection"
        ),
        inventoriedBy: this.$t(
          "lostItems.tabs.Inventoried.table.headings.inventoriedBy"
        ),
        collector: this.$t(
          "lostItems.tabs.Inventoried.table.headings.collector"
        ),
        category: this.$t("lostItems.tabs.Inventoried.table.headings.category")
      },
      resolutionError: false
    };
  },
  async beforeMount() {
    await this.getCategory();
    await this.getItems();
  },
  methods: {
    getItems: async function() {
      this.$store.commit("global/SET_LOADING", true);
      let queries = {
        page: this.page,
        limit: 999999,
        published: true,
        status: "inventoried"
      };
      try {
        let items = [];
        const resp = await api.getLostItemsByStatus(queries);
        items = resp.result.result;

        this.items = items.map(item => {
          let category = this.categories.filter(
            cat => item.categoryId === cat.id
          );
          category = category.length > 0 ? category[0].name : "";
          item.category = category;
          item.formatDate = moment(item.inventoryDate).format("YYYY/MM/DD");
          item.formatTime = item.timeCollection;
          return item;
        });
        this.itemsToDownload();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    getCategory: async function() {
      let currentLanguage = localStorage.getItem("lang");
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getLostItemsCategorys(currentLanguage);
        this.categories = resp.categories;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    openModal: function(item, del) {
      this.modalActive = true;
      this.isToDelete = del;
      this.itemToDelete = item;
    },
    closeModal: function() {
      this.modalActive = false;
      this.resolution = "";
      this.isToDelete = false;
      this.itemToDelete = null;
      this.resolutionError = false;
    },
    deleteItem: async function(item) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        item.published = false;
        item.status = "deleted";
        const response = await api.updateItem(item.id, item);
        await this.getItems();
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    updateItem: async function(item) {
      const autor = this.$store.getters["session/author"];
      let newDate = new Date();
      let parseDate = moment(newDate).format("YYYY-MM-DD");
      let parseTime = moment(newDate).format("HH:MM");
      let params = {
        status: "inventoried",
        resolvedBy: autor,
        itemInfo: item.itemInfo,
        resolutionDate: newDate,
        resolution: this.resolution,
        commentary: item.commentary,
        published: false,
        dateCollection: item.dateCollection,
        timeCollection: item.timeCollection,
        placeCollection: item.placeCollection
      };
      if (this.resolution !== "") {
        const response = await api.updateItem(item.id, params);
        await this.getItems();
        this.closeModal();
      } else {
        this.resolutionError = true;
      }
    },
    itemsToDownload: function() {
      const itemsFields = [
        "folio",
        "itemInfo",
        "formatDate",
        "formatTime",
        "inventoriedBy",
        "collector",
        "category"
      ];

      let downloadArray = this.items.map(item => {
        let obj = {};
        itemsFields.forEach(field => {
          obj[this._translateHeader(field)] = item[field];
        });
        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    }
  },
  computed: {
    table_options: function() {
      return {
        columns: [
          "folio",
          "itemInfo",
          "category",
          "collector",
          "inventoryDate",
          "inventoriedBy",
          "resolutionAction",
          "actions"
        ],
        options: {
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            folio: this.$t("lostItems.tabs.Inventoried.table.headings.folio"),
            itemInfo: this.$t(
              "lostItems.tabs.Inventoried.table.headings.itemInfo"
            ),

            category: this.$t(
              "lostItems.tabs.Inventoried.table.headings.category"
            ),
            collector: this.$t(
              "lostItems.tabs.Inventoried.table.headings.collector"
            ),
            inventoryDate: this.$t(
              "lostItems.tabs.Inventoried.table.headings.inventoryDate"
            ),
            inventoriedBy: this.$t(
              "lostItems.tabs.Inventoried.table.headings.inventoriedBy"
            ),

            resolutionAction: this.$t(
              "lostItems.tabs.Inventoried.table.headings.resolutionAction"
            ),
            actions: this.$t(
              "lostItems.tabs.Inventoried.table.headings.actions"
            )
          },
          sortable: [
            "folio",
            "itemInfo",
            "category",
            "collector",
            "inventoryDate",
            "inventoriedBy"
          ],
          resizableColumns: false,
          filterable: ["itemInfo"],
          perPage: 10,
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          columnsClasses: {
            folio: "folio-col",
            itemInfo: "itemInfo-col",
            category: "category-col",
            collector: "collector-col",
            inventoryDate: "inventoryDate-col",
            inventoriedBy: "inventoriedBy-col",
            resolutionAction: "resolutionAction-col",
            actions: "actions-col"
          }
        }
      };
    },
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    }
  }
};
</script>

<style lang="scss">
.actions {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actions > * {
  cursor: pointer;
}
.actions > .edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: $black;
  }
}
</style>
<style>
.form-inline label {
  display: initial;
}
.details {
  text-transform: uppercase;
  color: #000;
}
.details:hover {
  text-transform: uppercase;
  color: #000;
}
.resolution {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}
.btn-resolution {
  border-radius: 0px !important;
  border: 1px solid #000 !important;
}
.radio-btn {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.radio-btn .group {
  display: flex;
  align-items: center;
  justify-content: start;
}
.radio-btn .group input {
  width: 10% !important;
}
.radio-btn .group label {
  margin-top: 0.4rem;
}
.controls {
  display: flex;
  align-items: center;
  justify-content: end;
}
.cancel-btn {
  cursor: pointer;
}
.cancel-btn:hover {
  text-decoration: underline;
}

.inventoriedClass .modal-container {
  max-width: 34vw !important;
  max-height: 60vh !important;
}
.inventoriedClass .modal-container .controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}
.bolded {
  font-weight: bold !important;
}
.controls span {
  cursor: pointer;
}
.controls span:hover {
  text-decoration: underline;
}
.btn-download {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0px !important;
}
.inventoriedClass .modal-container .error {
  background: #bb0a30;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.3rem;
}
.inventoriedClass .modal-container .error p {
  margin-top: 15px;
}
.bolded {
  font-weight: bold;
}
td {
  text-align: left !important;
  vertical-align: middle !important;
}
#VueTables_th--folio,
#VueTables_th--itemInfo {
  width: 170px !important;
}
#VueTables_th--categoryAndStatus,
#VueTables_th--folioAndStatus {
  width: 400px !important;
}
#VueTables_th--actions,
#VueTables_th--placeCollection,
#VueTables_th--collector,
#VueTables_th--userName,
#VueTables_th--resolutionAction,
#VueTables_th--category,
#VueTables_th--resolvedBy,
#VueTables_th--resolution {
  width: 240px !important;
}
#VueTables_th--inventoryDate {
  width: 320px !important;
}
#VueTables_th--inventoriedBy {
  width: 250px !important;
}
</style>
<style>
@media (min-width: 768px) and (max-width: 1440px) {
  .inventoriedClass .modal-container {
    max-width: 40vw !important;
    max-height: 60vh !important;
  }
}
</style>
